<template>
    <NavbarMenu/>
    <AdminNavbar v-if="state.isUserLogged"/>
    <div class="main-center" role="main">
        <router-view/>
    </div>

    <MaiALauncher/>

    <!-- UI utils -->
    <MaskModal/>
    <AlertPopup/>
    <DialogModal/>
    <AckPopup/>
    <LoginModal v-if="mainStore.isShowLogin"/>
    <TermsModal v-if="mainStore.isShowTerms"/>
    <CookiesModal v-if="mainStore.isShowCookies"/>
    <subscribe-newsletter-modal/>
</template>

<script setup lang="ts">
import {computed, onMounted, reactive} from "vue";

import {useMainStore} from "@/stores/mainStore";

import NavbarMenu from "@/components/NavbarMenu.vue";
import MaskModal from "@/components/MaskModal.vue";
import AlertPopup from "@/components/AlertPopup.vue";
import DialogModal from "@/components/DialogModal.vue";
import AckPopup from "@/components/AckPopup.vue";
import LoginModal from "@/components/LoginModal.vue";
import TermsModal from "@/components/TermsModal.vue";
import CookiesModal from "@/components/CookiesModal.vue";
import AdminNavbar from "@/components/admin/AdminNavbar.vue";
import SubscribeNewsletterModal from "@/components/SubscribeNewsletterModal.vue";
import MaiALauncher from "@/components/MaiALauncher.vue";


interface State {
    isUserLogged: boolean
}

// eslint-disable-next-line
const components = {NavbarMenu, AlertPopup, MaskModal, DialogModal, AckPopup, LoginModal, TermsModal, CookiesModal}

const mainStore = useMainStore();


const state: State = reactive({
    isUserLogged: computed<boolean>(() => !!mainStore.getLoggedUser),
})

onMounted(() => {
    mainStore.loadWhoAmI();
})

</script>

<style lang="scss">
.main-center {
    display: flex;
    flex-direction: column;
    width: 100%;
    /*min-height: 100vh;*/

    @media (max-width: $max-md-screen) {
        padding-top: 65px;
    }
}
</style>
